import React from "react";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react-lite";
import { useCommunitiesStore } from "communities/communities-listing/communities-page-context";

export const CommunitiesCount = observer(() => {
    const { t } = useTranslation();
    const communitiesStore = useCommunitiesStore();
    const listStore = communitiesStore.getListStore("communities");

    return (
        <div className={"text-xs font-light flex items-center gap-1"}>
            <span className={"truncate"}>
                {listStore.count} {t("communitiesPage.communities")}
            </span>
        </div>
    );
});
